class ShowFormPannel {
    constructor() {
        this.shadowRoot = window.shadowDOM.shadowRoot;
        this.formPannel = this.shadowRoot.querySelector(".anyTextArea");
        this.startChat = this.shadowRoot.querySelector(".startChat");
        this.welcomeContent = this.shadowRoot.querySelector(".welcomeContent");
        this.chatContainer = this.shadowRoot.querySelector(".any_botContent");
        this.anyHidden = "anyHidden";
        this.setBlock = "block";
        this.init();
    }
   
    init() {
        if (this.startChat) {
            this.startChat.addEventListener("click", (e) => {
                e.preventDefault();
                this.handleStart();
            });
        }
    }

    handleStart() {
        if (this.formPannel && this.welcomeContent) {
            this.formPannel.classList.remove(this.anyHidden);
            this.welcomeContent.classList.add(this.anyHidden);
               
            // Set cookie first
            jQuery.ajax({
                type: "POST",
                url: anyBacken.ajaxurl,
                dataType: "text",
                data: {
                    action: 'setCookie',
                    time: anyBacken.cookieTime,
                    nonce: anyBacken.nonce
                },
                success: (cookieResult) => {
                    console.log('Cookie set:', cookieResult);
                    // After cookie is set, get welcome message
                    this.getWelcomeMessage();
                },
                error: (jqXHR, textStatus, errorThrown) => {
                    console.error('Cookie setting error:', errorThrown);
                    // Try to get welcome message even if cookie setting fails
                    this.getWelcomeMessage();
                }
            });
        }
    }

    getWelcomeMessage() {
        // Add loader while waiting for welcome message
        const loaderHtml = `<div id="temp-loader" class="chat-loader">
            <div class="typing-indicator">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>`;
        this.chatContainer.innerHTML += loaderHtml;

        // Make API call for welcome message
        jQuery.ajax({
            type: "POST",
            url: anyBacken.ajaxurl,
            dataType: "text",
            timeout: 300000, // 5 minute timeout
            data: {
                action: "botActions",
                prompt: "Hola",
                nonce: anyBacken.nonce
            },
            success: (response) => {
                try {
                    console.log('Welcome message response:', response);
                    const parsedResponse = JSON.parse(response);
                    const { body, role, conversationId } = JSON.parse(parsedResponse);
                    
                    // Remove loader
                    const tempLoader = this.chatContainer.querySelector('#temp-loader');
                    if (tempLoader) {
                        tempLoader.remove();
                    }

                    // Add welcome message to chat with timestamp
                    const timeString = this.formatMessageDateTime();
                    this.chatContainer.innerHTML += `<div class="bublesAi">
                        <div class="any_subjectBoxWrapper">
                            <div class="any_subjectBox">
                                <img style="background-color:#${anyBacken.primaryColor};" 
                                     src="${anyBacken.botIcon}" 
                                     width="15px" 
                                     height="15px" 
                                     alt="botIcon">
                                <span class="any_botName">
                                    ${anyBacken.sparkName.replace(/(?:\-)/g, " ")}
                                </span>
                            </div>
                            <span style="background-color:#ffffff;">
                                ${body}
                            </span>
                            <small class="message-time">${timeString}</small>
                        </div>
                    </div>`;

                    // Set conversation ID cookie if provided
                    if (conversationId) {
                        this.setConversationCookie(conversationId);
                    }
                } catch (error) {
                    console.error('Error processing welcome message:', error);
                    
                    // Remove loader on error
                    const tempLoader = this.chatContainer.querySelector('#temp-loader');
                    if (tempLoader) {
                        tempLoader.remove();
                    }
                }
            },
            error: (jqXHR, textStatus, errorThrown) => {
                console.error('Welcome message error:', errorThrown);
                // Remove loader on error
                const tempLoader = this.chatContainer.querySelector('#temp-loader');
                if (tempLoader) {
                    tempLoader.remove();
                }
            }
        });
    }

    setConversationCookie(id) {
        let date = new Date();
        date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000); // 1 day
        document.cookie = `${anyBacken.historyCookie}=${id}; expires=${date}; path=/; Secure`;
    }

    formatMessageDateTime() {
        const now = new Date();
        return now.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        });
    }
}

export default ShowFormPannel;